import { connect } from "react-redux";
import { DetailsSubHeader } from "../../../../components/sectionHeader";
import { type Props as DetailsSubHeaderProps } from "../../../../components/sectionHeader/sectionSubHeader/SectionSubHeader";
import { type RootState } from "../../../Application/globaltypes/redux";

const mapStateToProps = (state: RootState, ownProps: DetailsSubHeaderProps & { showLastModified: boolean }) => {
  const externalLinks = state.library.externalLinks;
  return {
    isUpdateInProgress: externalLinks.entityState.isEntityCommandInProgress && ownProps.isUpdateInProgress,
    lastModifiedDateTime: ownProps.showLastModified
      ? externalLinks.entityState.lastModifiedDateTime ?? ownProps.lastModifiedDateTime
      : undefined,
  };
};

export default connect(mapStateToProps)(DetailsSubHeader);
